import $ from 'jquery';

const CategoryFilter = (el) => {
    const $el = $(el);
    $el.change(function() {
        this.form.submit();
    });
};

export default CategoryFilter;
